/**
 * LegalDisclaimerBox — Piccolo box legale mostrato in fondo a ogni pagina resort.
 *
 * ★ 2026-08-13 (Fase 51 · Compliance CONSOB) — Richiesta utente:
 *   "Contratto di compravendita immobiliare · Nessuna promessa di rendimento garantito"
 *
 * Design volutamente minimale, tono formale, presente in TUTTE le pagine resort.
 * Copia coordinata con team Legal HCF Property (Sofia BG).
 */
import React from 'react';
import { useTranslation, Trans } from 'react-i18next';
import { ShieldCheck, Scale, FileCheck2 } from 'lucide-react';

export function LegalDisclaimerBox({ className = '' }) {
  const { t } = useTranslation();
  return (
    <section
      className={`px-4 md:px-12 pb-10 md:pb-14 ${className}`}
      data-testid="legal-disclaimer-box"
    >
      <div className="max-w-4xl mx-auto">
        <div className="rounded-xl border border-border bg-[var(--surface-2)]/60 backdrop-blur-sm px-5 py-4 md:px-6 md:py-5">
          <div className="flex items-start gap-3">
            <div className="shrink-0 rounded-full bg-[hsl(var(--primary))]/10 p-2">
              <Scale className="w-4 h-4 text-[hsl(var(--primary))]" />
            </div>
            <div className="flex-1 min-w-0">
              <div className="text-[10px] md:text-[11px] tracking-[0.22em] uppercase text-[hsl(var(--primary))] font-semibold">
                {t('resortDetail.disclaimer.eyebrow', 'Informazioni legali')}
              </div>
              <p className="text-xs md:text-sm text-muted-foreground mt-1.5 leading-relaxed">
                <b className="text-foreground">{t('resortDetail.disclaimer.contractLabel', 'Contratto di compravendita immobiliare')}</b>
                <span className="mx-1.5 opacity-40">·</span>
                <b className="text-foreground">{t('resortDetail.disclaimer.noReturnGuarantee', 'Nessuna promessa di rendimento garantito')}</b>.
                <br className="hidden md:block" />
                {t('resortDetail.disclaimer.body2', "Ogni proiezione economica riportata sulle brochure e sui project financing è di natura indicativa, elaborata su ipotesi di occupancy, ADR e costi operativi che potranno variare nel tempo. Il risultato effettivo dipende da variabili di mercato, stagionalità, cambio valuta e gestione operativa. L'acquisto avviene tramite atto notarile locale, tra soggetto privato e sviluppatore, senza intermediazione finanziaria.")}
              </p>
              <div className="mt-3 flex flex-wrap items-center gap-x-4 gap-y-1.5 text-[10px] md:text-[11px] text-muted-foreground">
                <span className="inline-flex items-center gap-1">
                  <FileCheck2 className="w-3 h-3" /> {t('resortDetail.disclaimer.chipNotarial', 'Atto notarile locale')}
                </span>
                <span className="inline-flex items-center gap-1">
                  <ShieldCheck className="w-3 h-3" /> {t('resortDetail.disclaimer.chipNoSolicitation', 'Nessuna sollecitazione al pubblico risparmio')}
                </span>
                <span>
                  HCF Property · Sofia (BG) · <a href="mailto:legal@housecashflows.com" className="underline hover:text-[hsl(var(--primary))]">legal@housecashflows.com</a>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default LegalDisclaimerBox;
